import { StyledHeader,LogoContainer, Logo, UserInfo} from "./styles";
import { useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";

export const TopBar = () => {
	const navigate = useNavigate(); 
	const handleLogoClick = () => {                                                                        
    navigate('/test');
  };
	return (
		<StyledHeader>
			<LogoContainer>
        <Logo src="/assets/logos/logo_b.png" onClick={handleLogoClick} />
      </LogoContainer>
			<UserInfo>
				<FaUser />
				{'weflo'}
			</UserInfo>
		</StyledHeader>
	)
};